<!-- Inner Banner Start-->
<section class="inner-hero-banner">
  <div class="inner-hero-text">
    <h1 i18n>Our Services</h1>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#" i18n>Home</a></li>
        <li class="breadcrumb-item active" aria-current="page" i18n>
          Our Services
        </li>
      </ol>
    </nav>
  </div>
</section>
<!-- Line Animations Effect-->
<!-- <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div> -->
<!-- Inner Banner End -->
<!-- Start Feature Content Area -->
<section class="section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6 col-sm-12">
        <div
          class="about-image-block mt-0 wow fadeInUp"
          data-wow-delay="0.2s"
          data-wow-duration="1s"
        >
          <img
            src="assets/images/features/service-img02.jpg"
            class="img-fluid"
            alt=""
          />
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div
          class="about-text-block wow fadeInUp"
          data-wow-delay="0.2s"
          data-wow-duration="1s"
        >
          <div class="about-content">
            <h4 i18n>
              Our application
            </h4>
            <div class="text" i18n>
              Give businesses control by taking the guessing out of shopping
            </div>
            <ul class="bullet--list mt-4">
              <li i18n>
                <strong class="color-dark"
                  >Store customized virtual lineups</strong
                >
                <br />Give you the ability to build your own virtual lineup
                experience.
              </li>
              <li i18n>
                <strong class="color-dark">Customer loyalty & retention</strong
                ><br />
                Bring back customers to your business with on demand
                notification, favorite store and history.
              </li>
              <li i18n>
                <strong class="color-dark">Contextual analytics and data</strong
                ><br />
                Time & Location based data, de-identified so privacy comes first
                and capability of comparing your store into your ecosystem.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Feature Content Area -->
<!-- Start Features Area -->
<section class="section bg-light">
  <!-- Circle Animations Effect
  <ul class="circles fetures-circles">
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
  </ul>
  -->
  <div class="container">
    <div class="title-block mx-auto">
      <div class="section_title mb-4 text-center">
        <h2><span i18n>Why Choose Us</span></h2>
        <span
          class="scroll-title"
          data-enllax-ratio="2.5"
          data-enllax-type="foreground"
          data-enllax-direction="horizontal"
          i18n
          >Why Choose Us</span
        >
        <p class="section_subtitle mx-auto" i18n>
          We innovate by distributing the curve of clients.<br />
          EnLiiigne is not trying to improve lineups,<br />
          we're making them disappear!
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-sm-6 col-12">
        <div
          class="app-feature-block wow fadeInUp"
          data-wow-delay="0.2s"
          data-wow-duration="1s"
        >
          <div class="steps-hover-thumb"></div>
          <div class="features-info">
            <div class="featured-icons">
              <i class="mdi mdi-cellphone-text"></i>
            </div>
            <h3 i18n>See your lineup, live</h3>
            <div class="text" i18n>
              Per store, and in global view so you can manage your time more
              efficiently.
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-6 col-12">
        <div
          class="app-feature-block wow fadeInUp"
          data-wow-delay="0.3s"
          data-wow-duration="1s"
        >
          <div class="steps-hover-thumb"></div>
          <div class="features-info">
            <div class="featured-icons">
              <i class="mdi mdi-google-analytics"></i>
            </div>
            <h3 i18n>Time & Location based data and contextual analytics</h3>
            <div class="text" i18n>
              Improve your shop efficiency and shopping experience.
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-6 col-12">
        <div
          class="app-feature-block wow fadeInUp"
          data-wow-delay="0.4s"
          data-wow-duration="1s"
        >
          <div class="steps-hover-thumb"></div>
          <div class="features-info">
            <div class="featured-icons">
              <i class="mdi mdi-chart-bar"></i>
            </div>
            <h3 i18n>Redistribute your lineup</h3>
            <div class="text" i18n>
              Orchestrate in real time, to distribute the curve. Tells you where
              to go.
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-6 col-12">
        <div
          class="app-feature-block wow fadeInUp"
          data-wow-delay="0.5s"
          data-wow-duration="1s"
        >
          <div class="steps-hover-thumb"></div>
          <div class="features-info">
            <div class="featured-icons">
              <i class="mdi mdi-wrench"></i>
            </div>
            <h3 i18n>Store customized remote queue</h3>
            <div class="text" i18n>Fast line for slow customers.</div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-6 col-12">
        <div
          class="app-feature-block wow fadeInUp"
          data-wow-delay="0.6s"
          data-wow-duration="1s"
        >
          <div class="steps-hover-thumb"></div>
          <div class="features-info">
            <div class="featured-icons">
              <i class="mdi mdi-cellphone-message"></i>
            </div>
            <h3 i18n>On demand notification</h3>
            <div class="text" i18n>Attract customers during quiet period.</div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-6 col-12">
        <div
          class="app-feature-block wow fadeInUp"
          data-wow-delay="0.7s"
          data-wow-duration="1s"
        >
          <div class="steps-hover-thumb"></div>
          <div class="features-info">
            <div class="featured-icons">
              <i class="mdi mdi-human-female-boy"></i>
            </div>
            <h3 i18n>Accessibility without sacrificing efficiency</h3>
            <div class="text" i18n>
              Remove barriers, for people who can't physically stand in line, or
              don't have the time to.
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-6 col-12">
        <div
          class="app-feature-block wow fadeInUp"
          data-wow-delay="0.8s"
          data-wow-duration="1s"
        >
          <div class="steps-hover-thumb"></div>
          <div class="features-info">
            <div class="featured-icons">
              <i class="mdi mdi-heart"></i>
            </div>
            <h3 i18n>Favorite stores and saved history</h3>
            <div class="text" i18n>
              Customers retention and opportunity for loyalty rewards.
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-6 col-12">
        <div
          class="app-feature-block wow fadeInUp"
          data-wow-delay="0.9s"
          data-wow-duration="1s"
        >
          <div class="steps-hover-thumb"></div>
          <div class="features-info">
            <div class="featured-icons">
              <i class="mdi mdi-comment-quote"></i>
            </div>
            <h3 i18n>Instant, precise feedback</h3>
            <div class="text" i18n>
              Also access to help, live when needed for customers.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Features Area -->
<!-- Start Get Started Area -->
<section class="section started-bg">
  <div class="banner_wrapper">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-9">
          <h2 class="text-white" i18n>Don't wait in line, Wait EnLiiigne!</h2>
          <p class="text-white" i18n>Contact us now!</p>
        </div>
        <div class="col-md-3">
          <a
            href="javascript:void(0);"
            routerLink="/contact"
            class="btn btn-sm white-btn"
            i18n
            >Contact<i class="mdi mdi-arrow-right ml-2"></i
          ></a>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Get Started Area -->

<!-- Start Price Area -->
<section class="section" id="price">
  <div class="container">
    <div class="title-block mx-auto">
      <div class="section_title mb-4 text-center">
        <h2><span i18n>Price</span></h2>
        <span
          class="scroll-title"
          data-enllax-ratio="2.5"
          data-enllax-type="foreground"
          data-enllax-direction="horizontal"
          i18n
          >Price</span
        >
        <p class="section_subtitle mx-auto" i18n>
          We offer a personnalized service for you.<br />
          Contact us and we will check what is best for your business.
        </p>
      </div>
    </div>
    <div class="card-deck mb-2 text-center">
      <div class="card mb-4 shadow-sm">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Entreprise</h4>
        </div>
        <div class="card-body">
          <h1 class="card-title pricing-card-title">
            2,000$ <small class="text-muted">/ year</small>
          </h1>
          <ul class="list-unstyled mt-3 mb-4">
            <li>Unlimited users</li>
            <li>Unlimited lineups</li>
            <li>1 store emplacement</li>
            <li>Email support</li>
          </ul>
          <!--Add link for payment here-->
          <button type="button" class="btn btn-lg btn-block theme-btn">
            Get started
          </button>
        </div>
      </div>
      <div class="card mb-4 shadow-sm">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Personnalized</h4>
        </div>
        <div class="card-body">
          <h1 class="card-title pricing-card-title">
            Contact Us <small class="text-muted"></small>
          </h1>
          <ul class="list-unstyled mt-3 mb-4">
            <li><br /></li>
            <li>Ajust to your needs</li>
            <li>Don't wait and contact us</li>
            <li><br /></li>
          </ul>
          <button
            type="button"
            href="javascript:void(0);"
            routerLink="/contact"
            fragment="contact"
            class="btn btn-lg btn-block theme-btn"
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Start Help Area -->
<section class="section" id="FAQ">
  <div class="container">
    <div class="title-block mx-auto">
      <div class="section_title mb-4 text-center">
        <h2><span i18n>Frequently Asked</span></h2>
        <span
          class="scroll-title"
          data-enllax-ratio="2.5"
          data-enllax-type="foreground"
          data-enllax-direction="horizontal"
          i18n
          >Frequently Asked</span
        >
        <p class="section_subtitle mx-auto" i18n>
          You still have questions about EnLiiigne? <br />Here are the most
          asked questions about our product if it can help you. Otherwise, feel
          free to contact us or visit FAQ's section.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 mx-auto">
        <div
          id="accordion"
          class="faq-accordion-panel wow fadeInUp"
          data-wow-duration="1.5s"
        >
          <div class="question-card shadow-sm">
            <div class="card-header p-0" id="headingOne">
              <h4 class="mb-0">
                <button
                  class="btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  <span i18n>Feeling of skipping the line</span
                  ><span><i class="mdi mdi-menu-down caret-icon"></i></span>
                </button>
              </h4>
            </div>
            <div
              id="collapseOne"
              class="collapse"
              aria-labelledby="headingOne"
              data-parent="#accordion"
            >
              <div class="card-body">
                <p i18n>
                  To avoid people getting angry by seeing other skip the lineup,
                  we plan to inform the people with signs and QR codes at the
                  doors and windows so that way it will become as comprehensive
                  as a fast track at an attaction park or when you board a plane
                  by zone numbers.
                </p>
              </div>
            </div>
          </div>
          <div class="question-card shadow-sm">
            <div class="card-header p-0" id="headingTwo">
              <h4 class="mb-0">
                <button
                  class="btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  <span i18n>Free of Use for users</span
                  ><span><i class="mdi mdi-menu-down caret-icon"></i></span>
                </button>
              </h4>
            </div>
            <div
              id="collapseTwo"
              class="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordion"
            >
              <div class="card-body">
                <p i18n>
                  The application is completely free of use for customers and
                  there is no ads (pop-up or video) to block the view or
                  distract users.
                </p>
              </div>
            </div>
          </div>
          <div class="question-card shadow-sm">
            <div class="card-header p-0" id="headingThree">
              <h4 class="mb-0">
                <button
                  class="btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  <span i18n>Fully Support Android & IOS</span
                  ><span><i class="mdi mdi-menu-down caret-icon"></i></span>
                </button>
              </h4>
            </div>
            <div
              id="collapseThree"
              class="collapse"
              aria-labelledby="headingThree"
              data-parent="#accordion"
            >
              <div class="card-body">
                <p i18n>
                  We fully support both systems so a maximum of customers can
                  use it to improve their shopping experience.
                </p>
              </div>
            </div>
          </div>
          <div class="question-card shadow-sm">
            <div class="card-header p-0" id="headingFour">
              <h4 class="mb-0">
                <button
                  class="btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  <span i18n>How do we count people to maximize capacity?</span
                  ><span><i class="mdi mdi-menu-down caret-icon"></i></span>
                </button>
              </h4>
            </div>
            <div
              id="collapseFour"
              class="collapse"
              aria-labelledby="headingFour"
              data-parent="#accordion"
            >
              <div class="card-body">
                <p i18n>
                  We are planning that you have an employee that will track
                  entry and exit so we will be able to provide you precise data
                  on your capacity and attract more customers during quiet
                  period to reach your capacity every time it is possible. In
                  the future, we are planning to adapt our solution to best
                  respond your needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Help Area -->
